import { ContextKindKey } from '../types/types';

export function isMobileContextKind(
  contextKind: unknown,
): contextKind is ContextKindKey.DEVICE | ContextKindKey.APPLICATION {
  switch (contextKind) {
    case ContextKindKey.DEVICE:
    case ContextKindKey.APPLICATION:
      return true;
    default:
      return false;
  }
}
